export type RefuelStatus = 'loading' | 'error' | 'warning' | 'success';

export interface SaveRefuelResultLike {
  isError: boolean;
  caseNumber: string | null;
  dataMessage: string;
}

export const deriveRefuelStatus = ({
  isError,
  caseNumber,
  dataMessage,
}: SaveRefuelResultLike): RefuelStatus => {
  let status: RefuelStatus = 'loading';
  if (isError) {
    status = 'error';
  } else if (caseNumber && dataMessage) {
    status = 'warning';
  }
  if (caseNumber && dataMessage === '') {
    status = 'success';
  }
  return status;
};

export default deriveRefuelStatus;
